import { render } from "./BlFormFieldMultimodel.vue?vue&type=template&id=20193852&scoped=true"
import script from "./BlFormFieldMultimodel.vue?vue&type=script&lang=js"
export * from "./BlFormFieldMultimodel.vue?vue&type=script&lang=js"

import "./BlFormFieldMultimodel.vue?vue&type=style&index=0&id=20193852&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20193852"]])

export default __exports__